module.exports = __webpack_public_path__ + "static/media/md-medkit.8c82a570.svg";